void !function () {
  typeof self === 'undefined' && typeof global === 'object' ? global.self = global : null;
}();